<ng-container *ngIf="show">
    <div class="notification-button-wrapper">
        <lib-icon-button
            iconName="bell-outline"
            color="var(--ion-color-dark)"
            rippleColor="var(--ion-color-dark-80)"
            backgroundHoverColor="var(--ion-color-dark-80)"
            backgroundFocusedColor="var(--ion-color-dark-80)"
            backgroundColor="var(--ion-color-dark-20)"
            [buttonSize]="48"
            [size]="20"
            display="circle"
            [border]="true"
            (onClick)="goToNotifications()" />

        <ng-container *ngIf="hasNotifications">
            <div class="notification-available"></div>
            <div class="animation-pulse-fade notification-available"></div>
        </ng-container>
    </div>
</ng-container>
